import { MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import React from "react";

function BillingCircuitDetails({ circuitDetails }) {
  return (
    <>
      <MDBTable>
        <MDBTableHead>
          <tr>
            <th scope="col">Circuit Name (Quote ID)</th>
            <th scope="col">Price</th>
            <th scope="col">Start Date</th>
            <th scope="col">End Date</th>
          </tr>
        </MDBTableHead>
        <MDBTableBody>
          {circuitDetails &&
            circuitDetails.length > 0 &&
            circuitDetails.forEach((info) => (
              <>
                <tr>
                  <td scope="row">{info.circuit_name}</td>
                  <td scope="row">{info.price}</td>
                  <td scope="row">{info.start_date}</td>
                  <td scope="row">{info.end_date}</td>
                </tr>
              </>
            ))}
        </MDBTableBody>
      </MDBTable>
    </>
  );
}

export default BillingCircuitDetails;
